export default __webpack_public_path__ + "static/media/right_arrow.beacae37.svg";